module.exports = __webpack_public_path__ + "static/media/online-resources-vs-coding-bootcamps.bafa80d9.png";